var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrolling-banner"},[_c('div',{ref:"banner",staticClass:"banner-images"},_vm._l((_vm.extendedList),function(item,index){return _c('img',{key:`${item.id}-${index}`,class:['banner-img', `img-${index % _vm.list.length}`],attrs:{"src":item.img,"alt":item.alt || ''}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }